import { useEffect, useState } from 'react';
import { NotificationManager } from 'react-notifications';
import { RequestNewVersion } from '../../../classes/RequestNewVersion';

const useLinkPromotionsWithAgreementsModal = ({
  isModalShowing,
  setModalShowing,
  expedientId,
  document,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [promotions, setPromotions] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const selectedPromotions = promotions.filter((p) => p.selected);

      if (selectedPromotions.length === 0) {
        NotificationManager.warning('Debes seleccionar al menos una promoción');
        return;
      }

      const payload = {
        agreement_id: document.id,
        promotion_ids: selectedPromotions.map((p) => p.id),
      };

      const request = new RequestNewVersion(
        `${process.env.REACT_APP_URL_API_LARAVEL}/document_expedients/link_promotions_with_agreement`,
        'post',
        {},
        payload,
        {}
      );

      const response = await request.executeRequest();

      if (!response || response.code !== 200) {
        const errorMessage =
          response && response.response && response.response.message
            ? response.response.message.mesage
            : 'Error al vincular promociones';
        throw new Error(errorMessage);
      }

      NotificationManager.success('Promociones vinculadas correctamente');
      setModalShowing(false);
      window.location.reload();
    } catch (err) {
      console.error('Error al vincular:', err);
      setError('Ocurrió un error al vincular la promoción con el acuerdo.');
      NotificationManager.error(err.message || 'Error al vincular promociones');
    } finally {
      setLoading(false);
    }
  };

  const getPromotions = async () => {
    if (!expedientId) return;

    setLoading(true);
    try {
      const request = new RequestNewVersion(
        `${process.env.REACT_APP_URL_API_LARAVEL}/document_expedients/promotions_by_expedient_number/${expedientId}`,
        'get',
        null,
        {}
      );

      const responsePromotions = await request.executeRequest();

      if (responsePromotions && responsePromotions.code === 200) {
        const promotionsData = responsePromotions.response.promotions;

        if (promotionsData && Object.keys(promotionsData).length > 0) {
          const promotionsFormatted = formattedPromotions(promotionsData);
          setPromotions(promotionsFormatted);
        } else {
          setPromotions([]);
          NotificationManager.info('No se encontraron promociones disponibles para vincular');
        }
      } else {
        const errorMessage =
          responsePromotions && responsePromotions.response && responsePromotions.response.message
            ? responsePromotions.response.message
            : 'Error al obtener promociones';
        throw new Error(errorMessage);
      }
    } catch (err) {
      console.error('Error al obtener promociones:', err);
      setError(err.message);
      NotificationManager.error('Error al cargar las promociones');
      setPromotions([]);
    } finally {
      setLoading(false);
    }
  };

  const formattedPromotions = (promotions) => {
    if (!Array.isArray(promotions)) {
      return Object.keys(promotions).map((key) => ({
        id: promotions[key]['id'],
        title: promotions[key]['alias'] || promotions[key]['filename'],
        selected: false,
      }));
    }

    return promotions.map((promotion) => ({
      id: promotion['id'],
      title: promotion['alias'] || promotion['filename'],
      selected: false,
    }));
  };

  const togglePromotionSelection = (promotionId) => {
    setPromotions((prevPromotions) =>
      prevPromotions.map((promotion) =>
        promotion.id === promotionId ? { ...promotion, selected: !promotion.selected } : promotion
      )
    );
  };

  useEffect(() => {
    if (isModalShowing && expedientId) {
      getPromotions();
    }

    if (!isModalShowing) {
      setPromotions([]);
      setError(null);
    }
  }, [isModalShowing, expedientId]);

  return {
    loading,
    error,
    handleSubmit,
    promotions,
    setPromotions,
    togglePromotionSelection,
  };
};

export default useLinkPromotionsWithAgreementsModal;
